
const AppleCallback = () => {

    return (
        <center><h1>Apple</h1></center>
    )
}

export default AppleCallback;